<template>
  <div>
    <v-main
      style="padding: 0px"
    >

      <v-calendar
        :type="view"
        ref="shiftCalendar"
        locale="de"
        :now="today"
        v-model="navDate"
        :weekdays="weekformat"
        :events="events"
        :event-color="getEventColor"
        :event-text-color="getEventFontColor"
        @click:day="selectDate"
        @click:date="selectDate"
      ></v-calendar>
    </v-main>
  </div>
</template>

<script>
import config from "../../configuration.json";

export default {
  props: ["eventcolor", "eventcolortext","shiftplan", "view", "navDate"],
  data() {
    return {
      teamView: "day",
      today: new Date().toISOString().substring(0, 10),
      focusDate: new Date(),
      weekformat: [1, 2, 3, 4, 5, 6, 0],
      bottomNav: "loading",
      events: [],
      start: undefined,
      end: undefined,
      maxDays: 0,
    };
  },
  mounted(){
    this.loadData();
  },
  computed: {
    src: function()
    {
      return `${config.fileUrl}/wfm/${this.$router.currentRoute.path.substring(1)}upload.json`;
    }
  },
  methods: {
    //selectDate to emit data as event
    selectDate: function(event)
    {
      this.$emit('dayselected', event);
    },
    // set proper previous value (either day, week or month)
    prev: function() {
      this.$refs.shiftCalendar.prev();
    },
    // set proper next value (either day, week or month)
    next() {
      this.$refs.shiftCalendar.next();
    },
    //change view with calendar icon in navbar
    changeView: function() {
      // in other views than teamview, show current month and on switch current week
      if (this.view == "month") {
        this.view = "week";
      } else {
        this.view = "month";
      }
    },
    // get correct time labels for shift by shortcut
    getTimeLabels: function(key) {
      if (key != undefined && key != "") {
        switch (key.toLowerCase()) {
          case "g":
            return "Frei";
          case "":
            return "Frei";
          case "f":
            return "Früh";
          case "s":
            return "Spät";
          case "n":
            return "Nacht";
          case "r":
            return "Normal";
          case "aw":
            return "Abwesend";
          case "sem":
            return "Seminar";
          case "ku":
            return "Kurzarbeit";
          case "tu":
            return "Urlaub";
          case "gz":
            return "Gleitzeit";
          case "tz":
            return "frei wg. Teilzeit";
          case "kr":
            return "Krank";
          case "kk":
            return "Kurzarb. Krank";
          case "uu":
            return "Jokertage";
          case "az":
            return "Altersfreizeit";
          default:
            return key;
        }
      }
      return key;
    },
    // load data from endpoint
    loadData: function() {
      let self = this;
      //get correct shiftplan as json
      if(self.shiftplan != undefined) {
        // iterate over shiftplan
        for (let i = 0; i < self.shiftplan.length; i++) {
          //scroll to the current month
           //scroll to the current month
          self.focusDate.setDate(1);
          self.focusDate.setMonth(parseInt(self.shiftplan[i].month) - 1);
          self.focusDate.setYear(parseInt(self.shiftplan[i].year));

          //get the last day of the month e.g. 31 in December
          let copyDate = new Date(self.focusDate.getTime());
          copyDate.setMonth(copyDate.getMonth() + 1);
          copyDate.setDate(0);
          self.maxDays = copyDate.getDate();

          //load shift shiftplan
          self.parseShiftEvents(self.shiftplan[i]);
        }
      }
    },
    // parse events in shift
    parseShiftEvents: function(shiftplan) {
      let cal_color = [
        "#d72378",
        "#0050ff",
        "#ff643c",
        "#00c861",
        "#A6A6A6",
        "#000",
        "black",
        "pink",
      ];
      let timeframe = ["F", "R", "S", "N"];

      // iterate over timeframe of this shift
      for (let x = 0; x < timeframe.length; x++) {
        for (let i = 0; i < shiftplan.shifts.length; i++) {
          let shift = shiftplan.shifts[i];
          var tempPlan = undefined;

          for (
            let j = 0;
            j < shift.plan.length &&
            shift.plan[j] != undefined &&
            j < this.maxDays;
            j++
          ) {
            //if shift name is empty, stop here
            if (shift.name == undefined) {
              break;
            }

            // if temporary plan is empty, set its enddate to today
            let date = new Date(this.focusDate.getTime());
            date.setDate(j + 1);

            if (
              tempPlan != undefined &&
              tempPlan.name ==
                shift.name + "- " + this.getTimeLabels(shift.plan[j])
            ) {
              tempPlan.end = date.toISOString().substring(0, 10);
            } else {
              // push tempPlan to events and reset tempPlan after push
              if (tempPlan != undefined) {
                this.events.push(tempPlan);
                tempPlan = undefined;
              }

              // check if shift plan shortcut matched timeframe and then change tempPlan
              if (shift.plan[j].toUpperCase() == timeframe[x]) {
                tempPlan = {
                  name: shift.name + "-" + this.getTimeLabels(shift.plan[j]),
                  start: date.toISOString().substring(0, 10),
                  end: date.toISOString().substring(0, 10),
                  color: cal_color[i],
                };

                // push tempPlan to events and reset tempPlan after push
                this.events.push(tempPlan);
                tempPlan = undefined;
              }
            }
          }
        }
        // push tempPlan to events //correct, that here is no reset?
        if (tempPlan != undefined) {
          this.events.push(tempPlan);
        }
      }
    },
    // get proper color for event
    getEventColor(event) {
      return event.color;
    },
    // get proper font color for event
    getEventFontColor(event) {
      if (event.fontcolor != undefined) {
        return event.fontcolor;
      } else {
        return "#fff";
      }
    },
    // set current view
    setBottomNavView(bottomNavVar) {
      this.bottomNav = bottomNavVar;
    },
  },
};
</script>
